import { Link } from '@inertiajs/react';
import { Emblem } from '@/components/Emblem';

type WordmarkProps = {
  /** `lg` matches the footer's slightly larger mark (22px vs the header's 21px). */
  size?: 'default' | 'lg';
  className?: string;
  onClick?: React.MouseEventHandler;
};

/**
 * "The Touch" emblem + "PureTouch by Daniela" wordmark lockup, matching the
 * mockup's `.wordmark`/`.fm`. Always links home (mirrors the mockup's
 * `data-nav="home"` click behavior). The emblem is decorative here (the
 * adjacent text already conveys the name), so it renders `aria-hidden`.
 */
export const Wordmark = ({ size = 'default', className, onClick }: WordmarkProps) => (
  <Link href="/" onClick={onClick} className={`inline-flex items-center gap-2 ${className ?? ''}`}>
    <Emblem className={`text-primary-deep shrink-0 ${size === 'lg' ? 'size-[30px]' : 'size-7'}`} />
    <span
      className={`font-display inline-flex items-baseline gap-1.5 tracking-[.01em] ${
        size === 'lg' ? 'text-[22px]' : 'text-[21px]'
      }`}
    >
      <b className="font-semibold">PureTouch</b>
      <i className="text-ink-soft text-[0.85em] italic">by Daniela</i>
    </span>
  </Link>
);
